import "../gc-project-dashboard2/index.scss";
import { useContext, useEffect, useState } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { getDashBoardDataV2 } from "services/auth";
import { useHistory, useParams } from "react-router";
import { AppContext } from "context/AppProvider";
import ErrorBoundary from "components/error-boundary";
import {
  FilterNamesEnum,
  SCDashBoardType,
  NavigationPageEnum
} from "../models";
import ActionItems from "./action-items";
import RiskUpdateComponent from "../risk-update";

function SCProjectDashboard() {
  const history = useHistory();
  const { projectId } = useParams() as any;
  const { tokenRetrievalState, projectDetails } = useContext(ProjectContext);

  const {
    setSubmittalListFilter,
    setMaterialListFilter,
    setBidPackageListFilter
  } = useContext(AppContext);

  const [dashboardData, setDashboardData] = useState<SCDashBoardType>();

  const goToFiltered = (
    page: NavigationPageEnum,
    filter: FilterNamesEnum,
    value = undefined
  ) => {
    switch (page) {
      case NavigationPageEnum.MaterialLog:
        setMaterialListFilter({ key: filter.toString(), value });
        history.push("./materials");
        break;
      case NavigationPageEnum.SubmittalLog:
        setSubmittalListFilter({ key: filter.toString(), value });
        history.push("./submittals");
        break;
      case NavigationPageEnum.BidPackageLog:
        setBidPackageListFilter({ key: filter.toString(), value });
        history.push("./bid-packages");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const getDashBoardFuc = async () => {
      const response = await getDashBoardDataV2(tokenRetrievalState.token, {});

      if (response.success) {
        const { data } = response;
        setDashboardData(data.success);
      } else {
        console.error(response.error);
      }
    };

    if (tokenRetrievalState && tokenRetrievalState.token && projectDetails) {
      getDashBoardFuc();
    }
  }, [tokenRetrievalState, projectDetails]);

  return (
    <div className="flex flex-col h-full bg-white gc-project-dashboard">
      <div className="flex w-full py-2 px-6 font-medium items-center justify-between ">
        <div className="flex items-center">
          <div className="font-semibold text-xl pr-3">Dashboard</div>
        </div>
      </div>
      <div className="w-full bg-white flex px-5 py-2 mb-8 hideScroll">
        <div className="h-full grow pr-5 space-y-5">
          <ErrorBoundary>
            <ActionItems
              projectId={projectId}
              dashboardData={dashboardData}
              projectDetails={projectDetails}
              goToFiltered={goToFiltered}
              hasBidPackageAccess={false}
            />
          </ErrorBoundary>
          <ErrorBoundary>
            <RiskUpdateComponent
              dashboardData={dashboardData}
              goToFiltered={goToFiltered}
              source="sc"
            />
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
}
export default SCProjectDashboard;
